/** Únicos géneros elegibles. Cualquier otro valor guardado —"n/a", el viejo "other", lo que sea—
 * se normaliza a vacío (ver `normalizeSexValue`) y, como el campo es obligatorio, el guardia tiene
 * que elegir uno de estos. */
export const genderOptions = [
  { value: "male", label: "Masculino" },
  { value: "female", label: "Femenino" },
  { value: "nonBinary", label: "No binario" },
];
